/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev3_QuoteInputs */

const en_funnel_sq_rev3_quote = /** @type {(inputs: Funnel_Sq_Rev3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three papers on my walk to lab every morning. Total game changer for my PhD.`)
};

const es_funnel_sq_rev3_quote = /** @type {(inputs: Funnel_Sq_Rev3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres artículos cada mañana camino al laboratorio. Un antes y un después en mi doctorado.`)
};

/**
* | output |
* | --- |
* | "Three papers on my walk to lab every morning. Total game changer for my PhD." |
*
* @param {Funnel_Sq_Rev3_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev3_quote = /** @type {((inputs?: Funnel_Sq_Rev3_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev3_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev3_quote(inputs)
	return en_funnel_sq_rev3_quote(inputs)
});